export class ReportScreenModel {
    /** 相手メーカーID */
    makerId: string | null = null;
}
